import {
  getWeeklyDrivingReport as fetchWeeklyDrivingReport,
  getWeeklyDrivingReportPDF as fetchWeeklyDrivingReportPDF,
} from '../apiService';
import { WeeklyDrivingReport } from '../types/weeklyDrivingReport';

/**
 * Fetches the weekly driving report data for a given week start.
 * Throws an error if the fetch fails or data is missing.
 */
export const getWeeklyDrivingReport = async (weekStart?: string): Promise<WeeklyDrivingReport> => {
  const response = await fetchWeeklyDrivingReport(weekStart);
  if (!response?.ok || !response.data) {
    throw new Error(`Failed to fetch weekly driving report (status: ${response?.status})`);
  }
  return response.data;
};

// Backwards-compatible export used in tests
export const getWeeklyReport = async (weekStart?: string): Promise<WeeklyDrivingReport | null> =>
  fetchWeeklyReportSafely(weekStart);

const fetchWeeklyReportSafely = async (weekStart?: string): Promise<WeeklyDrivingReport | null> => {
  try {
    const response = await fetchWeeklyDrivingReport(weekStart);
    if (!response?.ok || !response.data) {
      return null;
    }
    return response.data;
  } catch {
    return null;
  }
};

/**
 * Fetches the weekly driving report PDF for a given week start.
 * Throws an error if the fetch fails or Blob is missing.
 */
export const getWeeklyDrivingReportPDF = async (weekStart?: string): Promise<Blob> => {
  const response = await fetchWeeklyDrivingReportPDF(weekStart);
  if (!response?.ok || !response.data) {
    throw new Error(`Failed to fetch weekly driving report PDF (status: ${response?.status})`);
  }
  return response.data;
}; 